export default __webpack_public_path__ + "assets/images/cup.82594d.avif";